export const onboardinErrorObject = (error) => ({
  message: error.message,
  // style: { borderRadius: "100px", border: "1px solid #000" },
  // type: "success",
  // button: true,
  distanceTop: 57,
});
export const succesMail = (message) => ({
  message,
  type: 'success',
  // button: true,
  distanceTop: 57,
});
export const successResponsive = (message) => ({
  message,
  style: {
    padding: '17px',
    borderRadius: '6px',
    height: 'auto',
    width: 'calc(100% - 48px)',
    boxShadow: '0 8px 28px 0 #49112929',
    minWidth: 'auto',
  },
  type: 'success',
  // button: true,
  distanceTop: 35,
});
export const errorResponsive = (message) => ({
  message,
  style: {
    padding: '17px',
    borderRadius: '6px',
    height: '56px',
    width: 'calc(100% - 48px)',
    boxShadow: '0 8px 28px 0 #49112929',
    minWidth: 'auto',
    overflow: 'Hidden',
    textOverflow: 'ellipsis',
  },
  distanceTop: 35,
});
export const succesLoginMail = (message) => ({
  message,
  style: { padding: '17px 24px', minWidth: '400px' },
  type: 'success',
  // button: true,
  distanceTop: 100,
});

export const validateErrorObject = (error) => ({
  message: error.message,
  // style: { borderRadius: "100px", border: "1px solid #000" },
  // type: "success",
  button: true,
  distanceBottom: 759,
});

export const loggedError = (message, distanceTop) => ({
  message,
  distanceTop: distanceTop || 181,
});
